import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
// using alpha 2 code for country names, and iso for locales
var LOCALES = [{
  market: 'FR',
  currency: 'EUR',
  symbol: '€',
  country: 'FR',
  language: 'fr',
  iso: 'fr-FR',
  isoMirakl: 'fr_FR',
  name: 'Français'
}, {
  market: 'BE',
  currency: 'EUR',
  symbol: '€',
  country: 'BE',
  language: 'nl',
  iso: 'nl-BE',
  isoMirakl: 'nl_BE',
  name: 'België (Nederlands)'
}, {
  market: 'BE',
  currency: 'EUR',
  symbol: '€',
  country: 'BE',
  language: 'fr',
  iso: 'fr-BE',
  isoMirakl: 'fr_BE',
  name: 'Belgique (Français)'
}, {
  market: 'DE',
  currency: 'EUR',
  symbol: '€',
  country: 'DE',
  language: 'de',
  iso: 'de-DE',
  isoMirakl: 'de_DE',
  name: 'Deutschland'
}, {
  market: 'ES',
  currency: 'EUR',
  symbol: '€',
  country: 'ES',
  language: 'es',
  iso: 'es-ES',
  isoMirakl: 'es_ES',
  name: 'España'
}, {
  market: 'IT',
  currency: 'EUR',
  symbol: '€',
  country: 'IT',
  language: 'it',
  iso: 'it-IT',
  isoMirakl: 'it_IT',
  name: 'Italia'
}, {
  market: 'LU',
  currency: 'EUR',
  symbol: '€',
  country: 'LU',
  language: 'fr',
  iso: 'fr-LU',
  isoMirakl: 'fr_LU',
  name: 'Luxembourg'
}, {
  market: 'NL',
  currency: 'EUR',
  symbol: '€',
  country: 'NL',
  language: 'nl',
  iso: 'nl-NL',
  isoMirakl: 'nl_NL',
  name: 'Nederland'
}, {
  market: 'AT',
  currency: 'EUR',
  symbol: '€',
  country: 'AT',
  language: 'de',
  iso: 'de-AT',
  isoMirakl: 'de_AT',
  name: 'Österreich'
}, {
  market: 'PT',
  currency: 'EUR',
  symbol: '€',
  country: 'PT',
  language: 'pt',
  iso: 'pt-PT',
  isoMirakl: 'pt_PT',
  name: 'Portugal'
}, {
  market: 'CH',
  currency: 'CHF',
  symbol: 'CHF',
  country: 'CH',
  language: 'de',
  iso: 'de-CH',
  isoMirakl: 'de_CH',
  name: 'Schweiz (Deutsch)'
}, {
  market: 'CH',
  currency: 'CHF',
  symbol: 'CHF',
  country: 'CH',
  language: 'it',
  iso: 'it-CH',
  isoMirakl: 'it_CH',
  name: 'Svizzera (Italiano)'
}, {
  market: 'CH',
  currency: 'CHF',
  symbol: 'CHF',
  country: 'CH',
  language: 'fr',
  iso: 'fr-CH',
  isoMirakl: 'fr_CH',
  name: 'Suisse (Français)'
}, {
  market: 'UK',
  currency: 'GBP',
  symbol: '£',
  country: 'GB',
  language: 'en',
  iso: 'en-GB',
  isoMirakl: 'en_GB',
  name: 'United Kingdom'
}];
var SERVICE_NUMBER = [{
  number: '0805 98 12 84',
  market: 'FR',
  language: 'fr'
}, {
  number: '080 07 59 63',
  market: 'BE',
  language: 'nl'
}, {
  number: '080 07 59 63',
  market: 'BE',
  language: 'fr'
}, {
  number: '900 99 33 52',
  market: 'ES',
  language: 'es'
}, {
  number: '0800 180 65 33',
  market: 'DE',
  language: 'de'
}, {
  number: '800 87 07 99',
  market: 'IT',
  language: 'it'
}, {
  number: '800 25 460',
  market: 'LU',
  language: 'fr'
}, {
  number: '0800 02 28 216',
  market: 'NL',
  language: 'nl'
}, {
  number: '0800 29 52 80',
  market: 'AT',
  language: 'de'
}, {
  number: '800 83 31 73',
  market: 'PT',
  language: 'pt'
}, {
  number: '0800 83 66 05',
  market: 'CH',
  language: 'de'
}, {
  number: '0800 83 66 05',
  market: 'CH',
  language: 'it'
}, {
  number: '0800 83 66 05',
  market: 'CH',
  language: 'fr'
}, {
  number: '0808 234 21 72',
  market: 'UK',
  language: 'en'
}];
var DEFAULT_LOCALE = {
  market: 'FR',
  currency: 'EUR',
  symbol: '€',
  country: 'FR',
  language: 'fr',
  iso: 'fr-FR',
  name: 'Français'
};
var BYTES = {
  FR: ['octets', 'Ko', 'Mo', 'Go'],
  UK: ['bytes', 'Kb', 'Mb', 'Gb']
};
export { LOCALES, DEFAULT_LOCALE, SERVICE_NUMBER, BYTES };